import Vue from "vue";
import axios from "axios";
import vueFilters from "./vue-filters";
import {
    getCustomCart,
    updateAddressCountry,
    updateAddress,
    updateEmail,
    updateOrderWantsInvoice,
    updateCartAddresses,
    updateCart,
    updateShippingMethod,
} from "./request";

function debounce(callback, wait, immediate = false) {
    let timeout = null;

    return function () {
        const callNow = immediate && !timeout;
        const next = () => callback.apply(this, arguments);

        clearTimeout(timeout);
        timeout = setTimeout(next, wait);

        if (callNow) {
            next();
        }
    };
}

const processErrors = (dto) => {
    if (dto.error) {
        var err = dto.error;
        var errors = dto.cart.errors;

        console.error(err, errors);
    }
};

export default function init() {
    var el = document.getElementById("checkout-info-app");
    if (!el) return;
    var token = el.getAttribute("data-token");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: vueFilters,
        data: {
            loading: true,
            submitting: false,
            showShippingAddress: document.getElementById("showShippingAddress") ? document.getElementById("showShippingAddress").checked == true : false,
            cart: null,
            cartErrors: null,
            orderWantsInvoice: document.getElementById("orderWantsInvoice").checked == true,
            email: document.getElementById("email") ? document.getElementById("email").value : "",
            billingAddressFirstName: document.getElementById("billingAddressFirstName").value,
            billingAddressLastName: document.getElementById("billingAddressLastName").value,
            billingAddressAddress1: document.getElementById("billingAddressAddress1").value,
            billingAddressZipCode: document.getElementById("billingAddressZipCode").value,
            billingAddressCity: document.getElementById("billingAddressCity").value,
            billingAddressCountry: document.getElementById("billingAddressCountry").value,
            billingAddressPhone: document.getElementById("billingAddressPhone").value,
            billingAddressBusinessTaxId: document.getElementById("billingAddressBusinessTaxId")
                .value,
            billingAddressBusinessName: document.getElementById("billingAddressBusinessName").value,
            shippingAddressFirstName: document.getElementById("shippingAddressFirstName") ? document.getElementById("shippingAddressFirstName").value : "",
            shippingAddressLastName: document.getElementById("shippingAddressLastName") ? document.getElementById("shippingAddressLastName").value : "",
            shippingAddressAddress1: document.getElementById("shippingAddressAddress1") ? document.getElementById("shippingAddressAddress1").value : "",
            shippingAddressZipCode: document.getElementById("shippingAddressZipCode") ? document.getElementById("shippingAddressZipCode").value : "",
            shippingAddressCity: document.getElementById("shippingAddressCity") ? document.getElementById("shippingAddressCity").value : "",
            shippingAddressCountry: document.getElementById("shippingAddressCountry") ? document.getElementById("shippingAddressCountry").value : "",
        },
        mounted: async function () {
            await this.loadCart();
            this.loading = false;
        },
        computed: {
            // isValid: function() {
            //     return this.shippingMethod && this.country && this.totalPrice > 0;
            // }
        },
        methods: {
            onChangeShippingCountry: async function (e) {
                //console.log("change shipping country");
                if (this.cart.shippingAddress.id) {
                    var result = await updateAddressCountry(
                        token,
                        this.cart.shippingAddress.id,
                        e.target.value
                    );
                    await this.loadCart();
                }
            },
            onChangeBillingCountry: async function (e) {
                //console.log("change billing country", this.cart.billingAddress.id);
                if (this.cart.billingAddress.id) {
                    var result = await updateAddressCountry(
                        token,
                        this.cart.billingAddress.id,
                        e.target.value
                    );
                    await this.loadCart();
                }
            },
            onChangeShippingMethod: async function(handle,e) {
                await updateShippingMethod(
                    token,
                    handle
                );
                if(handle == "pickup" && this.showShippingAddress) {
                    this.showShippingAddress = false;
                    this.onChangeShowShippingAddress()
                }
                await this.loadCart();
            },
            onChangeShowShippingAddress: async function (e) {
                if (this.showShippingAddress) {
                    // Different shipping address
                    // this.loading = true;
                    axios
                        .post(
                            "/actions/itspersonal-module/cart/set-separate-billing-shipping-address",
                            null,
                            { headers: { "X-CSRF-Token": token } }
                        )
                        .then(() => {
                            // this.loading = false;
                        });
                    this.shippingAddressFirstName = "";
                    this.shippingAddressLastName = "";
                    this.shippingAddressAddress1 = "";
                    this.shippingAddressZipCode = "";
                    this.shippingAddressCity = "";
                    this.shippingAddressCountry = "";
                } else {
                    // Same shipping address
                    // this.loading = true;
                    axios
                        .post(
                            "/actions/itspersonal-module/cart/set-same-billing-shipping-address",
                            null,
                            { headers: { "X-CSRF-Token": token } }
                        )
                        .then(() => {
                            // this.loading = false;
                        });
                }
                await this.loadCart();
            },
            loadCart: async function (showLoader) {
                var result = await getCustomCart();
                this.cart = result.data.cart;
            },
            submitCart: async function (e) {
                e.preventDefault();
                this.submitting = true;
                if (!this.showShippingAddress) {
                    //console.log("copy from billing to shipping address");
                    // copy from billing to shipping address
                    this.shippingAddressFirstName = this.billingAddressFirstName;
                    this.shippingAddressLastName = this.billingAddressLastName;
                    this.shippingAddressAddress1 = this.billingAddressAddress1;
                    this.shippingAddressZipCode = this.billingAddressZipCode;
                    this.shippingAddressCity = this.billingAddressCity;
                    this.shippingAddressCountry = this.billingAddressCountry;
                }

                const [
                    billingResult,
                    shippingResult,
                    emailResult,
                    // addressesResult,
                    wantsInvoiceResult,
                ] = await Promise.all([
                    updateAddress(
                        token,
                        this.cart.billingAddress.id,
                        this.billingAddressAddress1,
                        this.billingAddressZipCode,
                        this.billingAddressCity,
                        this.billingAddressCountry,
                        this.billingAddressFirstName,
                        this.billingAddressLastName,
                        this.billingAddressPhone,
                        this.orderWantsInvoice ? this.billingAddressBusinessTaxId : "",
                        this.orderWantsInvoice ? this.billingAddressBusinessName : ""
                    ),
                    updateAddress(
                        token,
                        this.cart.shippingAddress.id,
                        this.shippingAddressAddress1,
                        this.shippingAddressZipCode,
                        this.shippingAddressCity,
                        this.shippingAddressCountry,
                        this.shippingAddressFirstName,
                        this.shippingAddressLastName
                    ),
                    updateEmail(token, this.email),
                    // updateCartAddresses(
                    //     token,
                    //     this.cart.billingAddress.id,
                    //     this.cart.shippingAddress.id
                    // ),
                    updateOrderWantsInvoice(token, this.orderWantsInvoice ? "1" : "0"),
                ]);

                document.getElementById("payment-form").submit();
            },
        },
        watch: {},
    });
}
